import type { BranchBannerContent, CardFinderBranch } from './types';

const EYEBROW = 'CardFinder: Free card recommendation quiz';
const CTA_LABEL = 'Get matched';
const FOOTNOTE = '1-2 minutes · No impact to credit score';

/**
 * Copy, illustration, and CTA target for each treatment2 branch variant. All 5 branches
 * share the same layout/component (CardFinderBranchEntrypoint) -- update this config to
 * change copy or illustration for a branch without touching the component.
 */
export const BRANCH_CONTENT: Record<CardFinderBranch, BranchBannerContent> = {
  travel: {
    eyebrow: EYEBROW,
    headlineLead: 'Every travel card promises the world.',
    headlineHighlight: "We'll match you with one that can actually be worth it for you.",
    ctaLabel: CTA_LABEL,
    footnote: FOOTNOTE,
  },
  'cash-back': {
    eyebrow: EYEBROW,
    headlineLead: 'Your spending has a pattern.',
    headlineHighlight: "We'll match you with a card that can reward it.",
    ctaLabel: CTA_LABEL,
    footnote: FOOTNOTE,
  },
  'balance-transfer': {
    eyebrow: EYEBROW,
    headlineLead: 'Not all transfer offers are equal.',
    headlineHighlight: "We'll find one that helps you save more.",
    ctaLabel: CTA_LABEL,
    footnote: FOOTNOTE,
  },
  'saving-interest': {
    eyebrow: EYEBROW,
    headlineLead: 'Planning a big purchase?',
    headlineHighlight: "We'll match you with a card that can help, interest-free.",
    ctaLabel: CTA_LABEL,
    footnote: FOOTNOTE,
  },
  'building-credit': {
    eyebrow: EYEBROW,
    headlineLead: "Building credit shouldn't feel confusing.",
    headlineHighlight: "We'll match you with a card that can make it simple.",
    ctaLabel: CTA_LABEL,
    footnote: FOOTNOTE,
  },
};
